import TwitterLogo from "../assets/twitter-logo.png";
import DiscordLogo from "../assets/discord-logo.png";
import "./Footer.scss";

import phone from "../assets/rg-logo-footer.png";

const Footer = ({ displayPhone = true }: { displayPhone?: boolean }) => {
  return (
    <>
      <div className="footer-container">
        <div className="columns is-vcentered footer-columns">
          <div className="column is-4 social-icon-container">
            <a
              href="https://twitter.com/replyguys_nft"
              target="_blank"
              rel="noreferrer"
            >
              <img src={TwitterLogo} className="twitter-icon" alt="twitter" />
            </a>
            <span>
              <a
                href="https://discord.gg/replyguys"
                target="_blank"
                rel="noreferrer"
              >
                <img src={DiscordLogo} className="discord-icon" alt="discord" />
              </a>
            </span>
          </div>

          <div className="column is-4 has-text-centered">
            <div className="footer-text">Reply guys</div>
            <div className="footer-text-small footer-text">
              Build a community one reply at a time
            </div>
          </div>
          {displayPhone && (
            <div className="column  is-4 has-text-centered phone-column">
              <img className="phone-image" alt="phone" src={phone}></img>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Footer;
